export default "__VITE_ASSET__CYRPKzeY__"